// extracted by mini-css-extract-plugin
export default {"wrapper":"Input_wrapper__2fGRs","input":"Input_input__Kh-cM","label":"Input_label__xk-yq","error":"Input_error__M6yY1"};